import { get } from "../config/api";

export interface Procurador {
  matricula: string;
  nome: string;
  cargo: string | null;
  ativo: boolean;
}

export interface Honorarios {
  bruto: number | null;
  outrasDeducoes: number | null;
  irRetido: number | null;
  liquido: number | null;
}

export interface Auxilios {
  saude: number | null;
  alimentacao: number | null;
}

export interface ValoresProcurador {
  honorarios: Honorarios | null;
  auxilios: Auxilios | null;
}

export interface Periodo {
  mes: number;
  ano: number;
  observacaoHonorarios: string | null;
  observacaoAuxilios: string | null;
}

export default class TransparenciaService {
  public static async procuradores() {
    return get<Procurador[]>("/transparencia/procuradores");
  }

  public static async periodos() {
    return get<Periodo[]>("/transparencia/periodos");
  }

  public static async valores(matricula: string, mes: number, ano: number) {
    return get<ValoresProcurador>("/transparencia/valores", { matricula, mes, ano });
  }
}
